
import React from 'react';
import { Button } from '@/components/ui/button';

const QuickNav = () => {
  const sections = [
    { id: 'story', label: 'Ons Verhaal' },
    { id: 'timeline', label: 'Tijdlijn' },
    { id: 'impact', label: 'Impact' },
    { id: 'mission', label: 'Missie' },
    
    { id: 'values', label: 'Waarden' }
  ];

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav aria-label="Page sections" className="pt-16 pb-5 bg-white sticky top-0 z-20 border-b border-gray-100 hidden md:block shadow-sm">
      <div className="container">
        <div className="flex items-center gap-1 overflow-x-auto pb-2 scrollbar-hide">
          {sections.map((section) => (
            <Button 
              key={section.id}
              variant="ghost" 
              size="sm"
              onClick={() => scrollToSection(section.id)}
              className="whitespace-nowrap text-sm"
            >
              {section.label}
            </Button>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default QuickNav;
